import ms from 'ms'

export const TAPECHART_CACHE_TIMES = {
  readiness: ms('1 minute'),
  rates: ms('1 hour'),
  homes: ms('1 hour'),
  hotelInfo: ms('3 hours'),
  hotelRooms: ms('6 hours'),
}
